import { Fragment } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import "./App.css";
import AppProvider from "./App.provider";
import Authenticate from "./components/Authenticate/Authenticate";
import Template from "./components/Template/Template";
import { AppRouters } from "./config/AppRouter/AppRouters.menu";
import NotFound from "./pages/Common/NotFound";

const App = () => {
    return (
        <AppProvider>
            <BrowserRouter basename="/gas-system">
                <Routes>
                    <Route path={process.env.REACT_APP_AUTHENTICATE_PAGE} element={<Authenticate />} />
                    <Route path="/" element={<Template />}>
                        {AppRouters.map((router, index) => (
                            <Fragment key={index}>
                                <Route path={router.to} element={router.Component} />
                            </Fragment>
                        ))}
                        <Route path={process.env.REACT_APP_UNAUTHORIZED_PAGE} element={<p>Unauhorized</p>} />
                        <Route path="/404" element={<NotFound />} />
                        <Route path="*" element={<Navigate to="/404" replace />} />
                    </Route>
                </Routes>
            </BrowserRouter>
        </AppProvider>
    );
};

export default App;
